import clsx from 'clsx';
import { inputFieldStyles } from './input-field.style';

type InputFieldProps = {
    id?: string;
    label: string;
	placeholder?: string;
	required?: boolean;
	icon?: React.ReactNode;
	hint?: string;
	children?: React.ReactNode;
	isSuccess?: boolean;
	isError?: boolean;
}

export const InputFieldWrapper = ({ label, id, required = false, hint, children, isSuccess, isError }: InputFieldProps) => {
	return (
		<div className={clsx('group', inputFieldStyles.inputContainer)} data-error={isError} data-success={isSuccess}>
			<label htmlFor={id} className={inputFieldStyles.inputLabel}>
				{required && <span className={inputFieldStyles.requiredMark}>*</span>}
				<span className={inputFieldStyles.labelText}>{label}</span>
			</label>
			{children}
			{hint && <div className={inputFieldStyles.inputHint} data-success={isSuccess}>{hint}</div>}
		</div>
	);
};

